
import React from "react";
import { Button } from "@/components/ui/button";
import { Facebook, Loader2 } from "lucide-react";
import { ConnectionState } from "./types";
import { initiateOAuthFlow } from "@/services/metaApi/auth";
import { META_APP_ID, META_SCOPES } from "@/services/metaApi/constants";

interface OAuthLoginTabProps {
  connectionStatus: { state: ConnectionState; message: string };
  handleConnect: () => Promise<void>;
}

export const OAuthLoginTab: React.FC<OAuthLoginTabProps> = ({
  connectionStatus,
  handleConnect
}) => {
  // Use the initiateOAuthFlow function directly
  const handleOAuthLogin = () => {
    initiateOAuthFlow();
  };
  
  return (
    <div className="text-center py-4">
      <p className="text-sm text-gray-500 mb-4">
        Nutze den OAuth-Flow zur Authentifizierung mit Meta. Es wird ein neues Fenster geöffnet, in dem du dich anmelden kannst.
      </p>
      <p className="text-xs text-amber-600 mb-4">
        Wichtig: Erlauben Sie Pop-ups für diese Website, damit das Anmeldefenster geöffnet werden kann.
      </p>
      <div className="bg-amber-50 border border-amber-200 rounded-md p-3 mb-4">
        <p className="text-xs text-amber-800">
          App ID: <strong>{META_APP_ID}</strong><br/>
          Scopes: <strong>{META_SCOPES.join(', ')}</strong><br/>
          Die exakte Redirect-URI ist: <strong>https://app.hoss-immo.de/meta-auth</strong><br/>
          Stellen Sie sicher, dass diese URL (ohne Änderungen) in Ihrer Meta App als gültige Redirect-URI konfiguriert ist.
        </p>
      </div>
      <Button
        onClick={handleOAuthLogin}
        className="bg-[#1877F2] hover:bg-[#0e6edc] text-white w-full"
        disabled={connectionStatus.state === ConnectionState.CONNECTING}
      >
        {connectionStatus.state === ConnectionState.CONNECTING ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Verbinde...
          </>
        ) : (
          <>
            <Facebook className="mr-2 h-4 w-4" />
            Mit Meta anmelden
          </>
        )}
      </Button>
    </div>
  );
}
